export default {
  'bindTo': 'this',
  'method': function(){
    alert('Pratiche')
  },
}
